import { alertActions } from "./alert.actions";
import { locationConstants } from "../_constants";
import { locationService } from "../_services";

export const locationActions = {
    getCities,
    getDistricts
};

function getCities() {
    return dispatch => {
        locationService.getCities().then(
            cities => dispatch(success(cities)),
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };

    function success(cities) {
        return { type: locationConstants.REQUEST_CITIES, cities };
    }
}

function getDistricts(cityId) {
    return dispatch => {
        locationService.getDistricts(cityId).then(
            districts => dispatch(success(districts)),
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };

    function success(districts) {
        return { type: locationConstants.REQUEST_DISTRICTS, districts };
    }
}



// WEBPACK FOOTER //
// ./src/_actions/location.actions.js